import api from "../../../api/comptabilite/_comptes";

export default {
    addCompteOperation(data) {
        return new Promise((resolve, reject) => {
            api.addCompteOperation(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })  
    },

    getCompteBanque() {
        return new Promise((resolve, reject) => {
            api.getCompteBanque().then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })  
    },

    getSoldeBanque() {
        return new Promise((resolve, reject) => {
            api.getSoldeBanque().then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })  
    },
}